import React, { useState } from 'react';
import JournalEntry from './JournalEntry';
import JournalEntityViewer from './JournalEntityViewer';
import AddNoteDialog from './AddNoteDialog';
import AskAboutDialog from './AskAboutDialog';
import NewEntityButton from './NewEntityButton';
import AskButton from './AskButton';
import classes from './Journal.module.css';
import AIService from '../../services/aiService';

const Journal = (props) => {
    const [entries, setEntries] = useState([]);
    const [entry, setEntry] = useState(null);
    const [noteEntry, setNoteEntry] = useState(null);
    const [askEntry, setAskEntry] = useState(null);
    const [pending, setPending] = useState(false);

    const addEntry = (tempEntry) => {
        let tempEntries = [...entries];
        tempEntries.push(tempEntry);
        setEntries(tempEntries);
    }
    const addNote = (noteTitle, text) => {
        let tempEntries = [...entries];
        let index = tempEntries.findIndex(s => s.name === noteTitle);
        let tempNote = {...tempEntries[index]};
        if(index > -1 && tempNote) {
            if(!tempNote.notes) {
                tempNote["notes"] = [];
            }
            tempNote.notes.push({ role: 'user', content: text });
        }
        tempEntries[index] = tempNote;
        setEntries(tempEntries);
    }

    const askAbout = (noteTitle, question) => {
        setPending(true);
        let tempEntries = [...entries];
        let index = tempEntries.findIndex(s => s.name === noteTitle);
        let tempNote = {...tempEntries[index]};
        console.info('askAbout', noteTitle, index, question, tempNote)
        AIService.getCompletionWithContext(question, tempNote.notes, 
            (data) => {
                tempNote.notes.push({ role: 'user', content: question });
                tempNote.notes.push({ role: 'assistant', content: data });
                setPending(false);
            },
            (error) => {
                console.info(error);
                alert('The GM had his mouth full of Cheez-Its and his response was unintelligible.');
                setPending(false);
            }
        );
        tempEntries[index] = tempNote;
        setEntries(tempEntries);
    }

    const entryList = entries.map((item, i) => {
        return <JournalEntry key={i} entry={item} click={(item) => { setEntry(item); }} showAskDialog={() => { setAskEntry(item); }} showNoteDialog={() => { setNoteEntry(item); }} addNote={addNote} askAbout={askAbout} />
    });

    return (
        <div className={classes.Journal}>
            <div className={classes.JournalTitle}>Journal</div>
            <div className={classes.JournalControls}>
                <NewEntityButton addEntry={addEntry} />
                <AskButton addEntry={addEntry} />
            </div>
            {entryList}
            <JournalEntityViewer entry={entry}  close={() => setEntry(null) } addNote={addNote} askAbout={askAbout} pending={pending} />
            <AddNoteDialog entry={noteEntry} close={() => setNoteEntry(null) } addNote={addNote} show={noteEntry != null} />
            <AskAboutDialog entry={askEntry} close={() => setAskEntry(null) } askAbout={askAbout} show={askEntry != null} />
        </div>
    );
}

export default Journal;